const getApiBaseUrl = () => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  const port = window.location.port;

  // Se estiver rodando via ngrok
  if (hostname.includes('ngrok-free.app') || hostname.includes('ngrok.io')) {
    // Para ngrok, usar a mesma URL base para API
    return `${protocol}//${hostname}/api`;
  }
  
  // Se estiver no Docker (nginx proxy na porta 9000)
  if ((hostname === 'localhost' || hostname === '0.0.0.0') && port === '9000') {
    return `${protocol}//${hostname}:${port}/api`;
  }
  
  // Se estiver no desenvolvimento local na porta 3000
  if ((hostname === 'localhost' || hostname === '0.0.0.0') && port === '3000') {
    return 'http://localhost:8080/api';
  }
  
  // Se estiver rodando no localhost sem porta específica ou outra porta
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0') {
    return 'http://localhost:8080/api';
  }
  
  // Se estiver no servidor de produção (IP direto)
  if (hostname === '206.189.163.247') {
    return `${protocol}//${hostname}/api`;  // Nginx proxy - URLs limpas
  }
  
  // Se estiver no domínio de produção
  if (hostname === 'abraliber.com.br' || hostname === 'www.abraliber.com.br') {
    return `${protocol}//${hostname}/api`;  // HTTPS com URLs limpas
  }
  
  // Para outros casos (produção, etc)
  return `${protocol}//${hostname}/api`;
};

const getStorageBaseUrl = () => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  const port = window.location.port;
  
  // Se estiver rodando via ngrok
  if (hostname.includes('ngrok-free.app') || hostname.includes('ngrok.io')) {
    return `${protocol}//${hostname}/storage`;
  }
  
  // Se estiver no Docker (nginx proxy na porta 9000)
  if ((hostname === 'localhost' || hostname === '0.0.0.0') && port === '9000') {
    return `${protocol}//${hostname}:${port}/storage`;
  }
  
  // Se estiver no desenvolvimento local
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0') {
    return 'http://localhost:8080/storage';
  }
  
  // Para outros casos
  return `${protocol}//${hostname}/storage`;
};

// URLs da API
export const API_BASE_URL = getApiBaseUrl();
export const API_AUTH_URL = `${API_BASE_URL.replace('/api', '')}/api/auth`;
export const API_STORAGE_URL = getStorageBaseUrl();

// Função helper para construir URLs completas
export const buildApiUrl = (endpoint) => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

export const buildStorageUrl = (path) => {
  if (!path) return '';
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_STORAGE_URL}/${cleanPath}`;
};
